import axios from "axios";

const port = import.meta.env.VITE_BACKEND_PORT || 3011;

const basePath = import.meta.env.VITE_API_URL || `http://localhost:${port}`;

const apiClient = axios.create({
  baseURL: basePath,
});

apiClient.defaults.headers.common["Accept"] = "application/json;charset=UTF-8";
apiClient.defaults.headers.common["Content-Type"] = "application/json;charset=UTF-8";

apiClient.interceptors.request.use((config) => {
  if (!config.params) return config;

  for (const param in config.params) {
    if (config.params[param] === "" || config.params[param] === undefined) {
      delete config.params[param];
    }
  }
  return config;
});

apiClient.interceptors.request.use((config) => {
  const clientId = import.meta.env.VITE_API_CLIENT_ID;
  const token = localStorage.getItem(`${clientId}_bearer`);
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
